<div class="contact-form-container">
  <div class="content">
    <h2 class="headline">
      {{ 'forms.contact.headline' | translate }}
    </h2>
    <kion-shop-contact-form
      (changed)="formChanged($event)"
    ></kion-shop-contact-form>
    <div class="actions">
      <kion-checkbox [boxes]="[checkbox]" (requiredSelected)="checkboxSelected($event)"></kion-checkbox>
      <div class="submit">
        <div class="spacer"></div>
        <kion-button
          mode="primary"
          [title]="'forms.contact.button.submit' | translate"
          [disabled]="!(canProceed$ | async)"
          [isLoading]="sending"
          [showTextWhileLoading]="true"
          (clicked)="sendMessage()"
        ></kion-button>
      </div>
    </div>
  </div>
</div>
